import AlfaLeasingForm from './components/AlfaLeasingForm';
import { AlfaLeasingFormState, AlfaLeasingFormViewProps } from './types';
import AlfaLeasingIntro from './components/AlfaLeasingIntro';
import AlfaLeasingQuiz from './components/AlfaLeasingQuiz';

const getContent = (params: AlfaLeasingFormViewProps) => {
  switch (params.state) {
    case AlfaLeasingFormState.LeasingIntro:
      return <AlfaLeasingIntro {...params.props} />;

    case AlfaLeasingFormState.LeasingQuiz:
      return <AlfaLeasingQuiz {...params.props} />;

    case AlfaLeasingFormState.LeasingForm:
      return <AlfaLeasingForm {...params.props} />;

    default:
      return <div>Default</div>;
  }
};

export function AlfaLeasingFormView(props: AlfaLeasingFormViewProps) {
  return getContent(props);
}
